/**
 * The detail pane with nothing open.
 *
 * Only ever seen on a desktop: on a phone the list fills the screen instead.
 * It exists because an empty half of the window is worse than a quiet one.
 */

import ZivDoodles from '../components/brand/ZivDoodles.jsx'
import './NoChatSelected.css'

export default function NoChatSelected() {
  return (
    <div className="nc">
      <ZivDoodles size={220} animate={false} />
      <h2 className="nc__title">ZIvapp for Web</h2>
      <p className="nc__text">
        Send and receive messages without keeping your phone online.
      </p>
      {/*
        This said "Your personal messages are end-to-end encrypted". They
        are not. ZIvapp has no end-to-end encryption yet — messages are
        protected in transit by TLS and stored readable on our server.

        A padlock and that sentence are a security promise, and a false
        one is worse than none: it tells somebody it is safe to send
        things here that it is not safe to send. The line now says what
        is true, and goes back to the original wording on the day the
        implementation earns it.
      */}
      <p className="nc__e2e">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="4" y="10" width="16" height="11" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
          <path d="M8 10V7.5a4 4 0 0 1 8 0V10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
        Your messages are encrypted in transit
      </p>
    </div>
  )
}
